import { IconConfig } from "../types";

export const history: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 24 24",
  elements: [
    {
      type: 'path',
      fill: "currentColor",
      d: "M4.543 8.916C5.803 5.465 9.116 3 13 3c4.967 0 9 4.033 9 9s-4.033 9-9 9a9 9 0 0 1-7.794-4.499 1 1 0 0 1 1.731-1.002A7.001 7.001 0 0 0 20 12c0-3.864-3.137-7-7-7a7.01 7.01 0 0 0-6.748 5.132l1.752-1a1 1 0 1 1 .992 1.736l-3.5 2a1 1 0 0 1-1.386-.412l-2-3.903a1 1 0 0 1 1.78-.912zM14 11.586l2.707 2.707a1 1 0 0 1-1.414 1.414l-3-3A1 1 0 0 1 12 12V8a1 1 0 0 1 2 0z"
    }
  ] as const
}
